import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getOrdersSale = async (params) => {
	const { data } = await axios.get(`${API}/client/orders_sale`, {
		params,
	});
	return data;
};

export const getCreate = async (params) => {
	const { data } = await axios.get(`${API}/client/orders_sale/data_orders`, {
		params,
	});
	return data;
};

export const validateExistenceOrderSale = async (order_sale_id, dealer_id, dealer_number) => {
	const newParams = {
		order_sale_id,
		dealer_number,
		dealer_id,
	};
	const { data } = await axios.get(`${API}/client/orders_sale/validate_existence`, {
		params: newParams,
	});
	return data;
};

export const saveOrderSale = async ({ params, base }) => {
	const { data } = await axios.post(`${API}/client/orders_sale/save`, {
		...base,
		params,
	});
	return data;
};

export const deleteOrderSale = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_sale/delete`, {
		...base,
		element,
	});
	return data;
};

export const receiveOrderSale = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_sale/receive`, {
		...base,
		element,
	});
	return data;
};

export const assignOrderSale = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_sale/assign_confirm`, {
		...base,
		element,
	});
	return data;
};
